export const USER_TYPES = {
    MANAGER: 'MANAGER',
    MEMBER: 'REGULAR',
    OWNER: 'OWNER'
};

// Authentication roles
export const AUTH_USER_ROLE = 'user';
export const AUTH_RECIPIENT_ROLE = 'recipient';

export const DEFAULT_GROUPS_OPTIONS = {
    from: 1,
    sort: 'name',
    dir: 'asc',
    to: 15,
    query: 'accountGroups'
};

export const DEFAULT_USERS_OPTIONS = {
    query: 'accountSenders',
    sort: 'name',
    dir: 'asc',
    from: 1,
    to: 15,
    search: ''
};

// Fallback used by the password-complexity UI before the real policy loads.
// Snake_case string keys mirror the security_settings API contract; consumers
// parse the individual values (number/boolean) at the edge of rendering.
export const DEFAULT_PASSWORD_POLICY = {
    minimum_password_length: '8',
    require_one_upper_character: 'true',
    require_one_lower_character: 'true',
    require_one_number_character: 'true',
    require_one_special_character: 'true',
    amount_minimum_rules_requirements: '3'
};

export const ADMIN_GROUPS_HEADINGS = {
    USERS: 'esl.account.account_role.permissions.users',
    APP_SETTING: 'esl.generic.application_settings',
    INTEGRATION: 'esl.generic.integration',
    SUBSCRIPTION: 'esl.generic.subscription_billing'
};

export const ACCOUNT_GROUPS_HEADINGS = {
    PROFILE: 'esl.generic.my_profile',
    SETTINGS: 'esl.generic.my_settings'
};

export const MIN_DELEGATION_START_DATE = '01-01-2017';
export const DELEGATION_STATUSES = {
    IN_PROGRESS: 'IN_PROGRESS',
    EXPIRED: 'EXPIRED',
    FUTURE: 'FUTURE'
};

export const FREE_USERS_PLAN_NAME = 'Free Users';
export const AUTHENTICATION_TYPE_USER = 'user';
export const AUTHENTICATION_TYPE_RECIPIENT = 'recipient';
